import { useQuery } from '@tanstack/react-query';
import { getPriceApplicationPermission } from '../services';

export const PRICE_APPLICATION_PERMISSION_QUERY_KEY = ['ipa.gerenciador.priceApplicationPermission'];

export type PriceApplicationPermission = {
  isAllowed: boolean;
  isChecking: boolean;
};

// Se a consulta falhar o botão fica liberado: o PATCH /all-products/apply já devolve 403 para quem não pode aplicar.
export const usePriceApplicationPermission = (): PriceApplicationPermission => {
  const { data, isLoading, isError } = useQuery({
    queryKey: PRICE_APPLICATION_PERMISSION_QUERY_KEY,
    queryFn: getPriceApplicationPermission,
    staleTime: 0,
    cacheTime: 0,
  });

  return {
    isAllowed: isError ? true : data?.allowed ?? false,
    isChecking: isLoading,
  };
};
